import React, { useMemo } from "react";
import Calendar from "../../../pages/FullCalendar/FullCalendar";
import "./style.scss";

const PNLCalendar = ({ accountsData }) => {
    const dailyStats = useMemo(() => {
        if (!accountsData?.program_objectives?.daily_stats) {
            return {};
        }
        return accountsData.program_objectives.daily_stats;
    }, [accountsData]);

    // console.log("PNL Calendar - accountsData:", accountsData);
    // console.log("PNL Calendar - dailyStats:", dailyStats);

    return (
        <div className="pnl-calendar-admin-wrapper">
            <Calendar data={dailyStats} />
        </div>
    );
};

export default PNLCalendar;
